export default {
  OWNER: "OWNER",
  ADMIN: "ADMIN",
  CLIENT: "CLIENT",
  SYSTEM_ADMIN: "SYSTEM_ADMIN"
}